"use strict";
import { __exports as u } from "./index.es449.js";
import { __require as A } from "./index.es383.js";
import { __require as x } from "./index.es382.js";
var d;
function v() {
  return d ? u : (d = 1, (function(c) {
    Object.defineProperty(c, "__esModule", {
      value: !0
    }), Object.defineProperty(c, "interpolateAs", {
      enumerable: !0,
      get: function() {
        return y;
      }
    });
    const m = A(), R = x();
    function y(o, s, g) {
      let t = "";
      const a = (0, R.getRouteRegex)(o), p = a.groups, l = (
        // Try to match the dynamic route against the asPath
        (s !== o ? (0, m.getRouteMatcher)(a)(s) : "") || // Fall back to reading the values from the href
        // TODO: should this take priority; also need to change in the router.
        g
      );
      t = o;
      const f = Object.keys(p);
      return f.every((r) => {
        let e = l[r] || "";
        const { repeat: n, optional: _ } = p[r];
        let i = "[" + (n ? "..." : "") + r + "]";
        return _ && (i = (e ? "" : "/") + "[" + i + "]"), n && !Array.isArray(e) && (e = [
          e
        ]), (_ || r in l) && // Interpolate group into data URL if present
        (t = t.replace(i, n ? e.map(
          // these values should be fully encoded instead of just
          // path delimiter escaped since they are being inserted
          // into the URL and we expect URL encoded segments
          // when parsing dynamic route params
          (q) => encodeURIComponent(q)
        ).join("/") : encodeURIComponent(e)) || "/");
      }) || (t = ""), {
        params: f,
        result: t
      };
    }
  })(u), u);
}
export {
  v as __require
};
//# sourceMappingURL=index.es381.js.map
